(function () {
  let swiperInstance;

  function init() {
    const el = document.querySelector('[data-customer-reviews-swiper]');
    if (!el || typeof Swiper === 'undefined') return;

    if (window.innerWidth >= 990) {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
      return;
    }

    if (swiperInstance) swiperInstance.destroy(true, true);

    swiperInstance = new Swiper(el, {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 10,
      navigation: {
        nextEl: el.querySelector('[data-customer-reviews-next]'),
        prevEl: el.querySelector('[data-customer-reviews-prev]')
      },
      pagination: {
        el: el.querySelector('.customer-reviews-slider__pagination'),
        clickable: true
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', init);
})();
